//#region src/utils/handleValueOrFn.ts
function handleValueOrFn(value, url, defaultValue) {
	if (typeof value === "function") return value(url);
	if (typeof value !== "undefined") return value;
	if (typeof defaultValue !== "undefined") return defaultValue;
	return void 0;
}

//#endregion
export { handleValueOrFn };
//# sourceMappingURL=handleValueOrFn-C3bdLKGZ.mjs.map